import { render, staticRenderFns } from "./NoRecipesFound.vue?vue&type=template&id=226fdf1c&scoped=true&"
import script from "./NoRecipesFound.vue?vue&type=script&lang=js&"
export * from "./NoRecipesFound.vue?vue&type=script&lang=js&"
import style0 from "./NoRecipesFound.vue?vue&type=style&index=0&id=226fdf1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226fdf1c",
  null
  
)

export default component.exports